import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicator = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: '보안 연결',
      description: 'SSL/TLS 암호화 적용',
      status: 'active'
    },
    {
      icon: 'Lock',
      title: '비밀번호 보호',
      description: '안전한 인증 시스템',
      status: 'active'
    },
    {
      icon: 'AlertTriangle',
      title: '로그인 시도 제한',
      description: '5회 실패 시 계정 잠금',
      status: 'warning'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground flex items-center space-x-2">
        <Icon name="ShieldCheck" size={18} color="var(--color-accent)" />
        <span>보안 기능</span>
      </h3>
      <div className="space-y-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className={`flex h-8 w-8 items-center justify-center rounded-lg ${
              feature?.status === 'active' ? 'bg-success/10' : 'bg-warning/10'
            }`}>
              <Icon 
                name={feature?.icon} 
                size={16} 
                color={feature?.status === 'active' ? 'var(--color-success)' : 'var(--color-warning)'} 
              />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">{feature?.title}</p>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityIndicator;